export default {
  'portal': 'https://test-portal.xunmengtu.com'
}